import { Link } from "react-router-dom";
import SectionLabel from "@/components/SectionLabel";
import { SERVICES } from "@/data/services";
import { ChevronRight } from "lucide-react";

export default function Services() {
  return (
    <div>
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionLabel>Services</SectionLabel>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 max-w-3xl">
            Comprehensive medical care tailored to your family.
          </h1>
          <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">
            From acute complaints to long-term chronic care — every service delivered with
            ethical, evidence-based medicine and the warmth of a family physician.
          </p>

          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s) => (
              <Link key={s.slug} to={`/services/${s.slug}`}
                    className="group rounded-2xl border border-slate-200/70 bg-white p-6 aarogya-shadow hover:-translate-y-1 hover:shadow-lg transition"
                    data-testid={`service-list-${s.slug}`}>
                <div className="h-11 w-11 rounded-xl grid place-items-center text-white"
                     style={{ background: "linear-gradient(135deg,#0A6EBD,#16A5B8)" }}>
                  <s.icon className="h-5 w-5" />
                </div>
                <div className="mt-4 font-serif text-xl text-slate-900 group-hover:text-[#0A6EBD]">{s.title}</div>
                <div className="mt-2 text-sm text-slate-600 leading-relaxed">{s.short}</div>
                <div className="mt-4 text-[13px] font-semibold text-[#0A6EBD] inline-flex items-center gap-1">
                  Learn more <ChevronRight className="h-4 w-4" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
